import { ChangeDetectionStrategy, Component, Inject, inject, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';
import { DataSourceDirective } from 'eurogard-data-source/directive';
import { DataSourceErrorComponent } from 'eurogard-data-source';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelContent,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatProgressBar } from '@angular/material/progress-bar';
import { PersistentAccordionDirective } from '@rxap/material-directives/expansion';
import {
  AlarmingSettingsPanelComponent,
} from 'angular-components/alarming-settings-panel/alarming-settings-panel.component';
import {
  SubscribedMachinesPanelComponent,
} from 'angular-components/subscribed-machines-panel/subscribed-machines-panel.component';
import {
  UserSettingsAccordionDataSource,
} from 'angular-components/layout/default-header/user-profile-icon/user-settings/user-settings-accordion.data-source';
import { ACCORDION_DATA_SOURCE } from 'eurogard-data-source/accordion';
import { MatListModule } from '@angular/material/list';
import { ReactiveFormsModule } from '@angular/forms';
import { UserMfaSettingsComponent } from 'angular-components/user-mfa-settings/user-mfa-settings.component';
import { FeatureInfoTextComponent } from 'angular-components/feature-info';
import { AuthorizationService, RXAP_AUTHORIZATION_SCOPE } from '@rxap/authorization';
import {
  RegistrationTokenFormComponent,
} from 'angular-components/registration-token-form/registration-token-form.component';
import {
  SubscribedRoutersPanelComponent,
} from 'angular-components/subscribed-routers-panel/subscribed-routers-panel.component';
import {
  UserAccountInformationComponent,
} from 'angular-components/layout/default-header/user-profile-icon/user-settings/user-account-information/user-account-information.component';

@Component({
  selector: 'eurogard-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: [ './user-settings.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    AsyncPipe,
    DataSourceDirective,
    DataSourceErrorComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelContent,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatProgressBar,
    PersistentAccordionDirective,
    AlarmingSettingsPanelComponent,
    SubscribedMachinesPanelComponent,
    MatListModule,
    ReactiveFormsModule,
    UserMfaSettingsComponent,
    FeatureInfoTextComponent,
    RegistrationTokenFormComponent,
    SubscribedRoutersPanelComponent,
    UserAccountInformationComponent,
  ],
  providers: [
    UserSettingsAccordionDataSource,
    {
      provide: ACCORDION_DATA_SOURCE,
      useExisting: UserSettingsAccordionDataSource,
    },
  ],
})
export class UserSettingsComponent {
  public readonly accordionDataSource = inject(UserSettingsAccordionDataSource);

  protected readonly hasPermissionDeviceInboxToken: boolean;

  constructor(
    @Inject(AuthorizationService)
    private readonly authorization: AuthorizationService,
    @Optional()
    @Inject(RXAP_AUTHORIZATION_SCOPE)
    private readonly scope: string | null = null,
  ) {
    this.hasPermissionDeviceInboxToken = this.authorization.hasPermission('thing.create', this.scope);
  }

}
